// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e541e0e8","62":"97353441","304":"c4e75677","462":"7929d5c8","714":"3d86ac3c","758":"fc3480d1"}[chunkId] + ".chunk.js";
};